import Client from "./Client";
import { AnyObject } from "types";
import { format } from "date-fns";

const resource = "/surveys";

export type AnswersFilter = {
  startDate: Date | null;
  endDate: Date | null;
  userId: number;
};

export type ReportsFilter = {
  userId?: number;
  year?: number;
  month?: number;
  day?: Date | null;
};

export default class AnswersService {
  public static async getAnswers(
    surveyId: number,
    page: number,
    size: number,
    filters: AnswersFilter
  ): Promise<AnyObject> {
    let url = `${resource}/${surveyId}/answers?page=${page}&page_size=${size}`;
    if (filters.startDate !== null && filters.endDate !== null) {
      url += `&start_date='${format(
        filters.startDate,
        "yyyy/MM/dd"
      )}'&end_date='${format(filters.endDate, "yyyy/MM/dd")}'`;
    }
    if (filters.userId !== 0) url += `&user=${filters.userId}`;
    const { data } = await Client.get(url);
    return data;
  }
  public static async getUsers(surveyId: number): Promise<AnyObject> {
    const { data } = await Client.get(`${resource}/${surveyId}/users`);
    return data;
  }
  public static async getMarkers(
    surveyId: number,
    filters: AnswersFilter
  ): Promise<AnyObject> {
    let url = `${resource}/${+surveyId}/answers_location?`;
    if (filters.startDate !== null && filters.endDate !== null) {
      url += `&start_date='${filters.startDate}'&end_date='${filters.endDate}'`;
    }
    if (filters.userId !== 0) url += `&user=${filters.userId}`;
    const { data } = await Client.get(url);
    return data;
  }

  public static async getAnswersReports(
    surveyId: number,
    filters: ReportsFilter
  ): Promise<AnyObject> {
    let url = `${resource}/${+surveyId}/answers_report?`;
    if (filters.userId && filters.userId !== 0)
      url += `&user=${filters.userId}`;
    if (filters.year && filters.year !== 0) url += `&year=${filters.year}`;
    if (filters.month && filters.month !== 0) url += `&month=${filters.month}`;

    if (filters.day) {
      const date = filters.day;

      const init = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        0,
        0
      );

      const end = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        23,
        59
      );

      url += `&init='${init}'`;
      url += `&end='${end}'`;
    }

    const { data } = await Client.get(url);
    return data;
  }
  public static async deleteAnswer(answerId: number): Promise<void> {
    if (answerId !== 0) await Client.delete(`/answers/${answerId}`);
  }

  public static async getImage(key: string): Promise<AnyObject> {
    const { data } = await Client.get(`/answers/download_image/${key}`);
    return data.data;
  }

  public static async saveAnswer(
    answers: Record<string, unknown>
  ): Promise<AnyObject> {
    const { data } = await Client.post("/answers/answers_web", answers);
    //console.log(data)
    return data.data;
  }
}
